module.exports = __webpack_public_path__ + "img/banner4.7f3ae04e.png";